<template>
<div class="__action-part-shipstation">
    <div class="layout-row flex flex-center gap-40 margin-b-30">
        <select-field
            class="flex"
            placeholder="Select an action to trigger"
            caption="Action"
            :loading="spin"
            @input="actionChanged($event)"
            :options="actions"
            label="caption"
            v-model="automation.type_id"/>

        <div class="form_group">
          <v-switch label="Use the customer optin email?" :value="automation.send_to_optin_email"
                    v-model="automation.send_to_optin_email"  @change="updated()"
                    info="When checked (default), the customer's optin email will be used when the automation is triggered instead of their payer email in case they're different.">
          </v-switch>
        </div>
    </div>

    <select-field v-if="automation.type_id && acLists.length" class="margin-b-20"
        caption="List"
        label="caption"
        @input="updated"
        :loading="spin"
        :options="acLists"
        v-model="automation.list"
        searchable clearable/>

  <div class="margin-b-20 layout-column"  v-if="automation.type_id && acLists.length">
    <v-switch v-model="automation.content.pushMeta" :value="automation.content.pushMeta"
              @change="updated()" label="Push meta data to Klaviyo?">
	    <template v-slot:info>
		    <div>
			    When selected Funnelish will Sync all customer meta data alongside each customer profile.
		    </div>
	    </template>
    </v-switch>
  </div>

	<div class="layout-row margin-b-20" v-if="stores.length">

		<div class="flex form-group with_top_block">
			<span class="form_group_top_block">Select a store</span>
			<v-select
					@input="updated"
					:options="stores"
					label="storeName"
					:searchable="true"
					:clearable="true"
					:reduce="x => x.storeId"
					v-model="automation.content.store_id"
					append-to-body
			>
				<template v-slot:option="option">
					<div class="layout-row">
						<span class="opt-name">{{ option.storeName }}</span>
						<span class="opt-sku">[{{ option.storeId }}]</span>
					</div>
				</template>
				<template #selected-option="option">
					<span class="opt-name">{{ option.storeName }}</span>
				</template>
			</v-select>
		</div>
	</div>

	<div class="layout-row margin-b-20" v-if="products.length">
		<div class="flex form-group with_top_block">
			<span class="form_group_top_block">Product</span>
			<v-select
					@input="acListSelect"
					:options="products"
					label="name"
					:searchable="true"
					:clearable="true"
					:reduce="x => x.id"
					v-model="automation.content.product_id"
					append-to-body
			>
				<template v-slot:option="option">
					<div class="layout-row">
						<span class="opt-name">{{ option.name }}</span>
						<span class="opt-sku">[{{ option.sku }}]</span>
					</div>
				</template>
				<template #selected-option="option">
					<span class="opt-name">{{ option.name }}</span>
				</template>
			</v-select>
		</div>
		<span class="" style="padding-bottom: 10px;margin: auto 10px;">X</span>
		<div class="qty">
			<input-field label="QTY" type="number" min="1" max="999999999" info="The quantity to create in ShipStation."
			             v-model.number="automation.content.qty" @change="updated" />
		</div>
	</div>

	<div class="layout-row " v-if="products.length">
		<div class="layout-row margin-r-30">
			<v-switch label="Enable bundling?" :value="automation.content.bundle"
			          v-model="automation.content.bundle" @change="updated">
				<template v-slot:info>
					<div class="">
						<p><b>If bundling is off,</b> then Funnelish will sync orders to Shopify as they are made on your funnel.
						</p>
						<p><b>If bundling is on,</b> then Funnelish will wait for the given time for the next order before
							attempting to sync to Shopify if there are no more waiting orders by the same customer.</p>
						<p>Usually <b>5 to 15 minutes</b> should be more than enough for a customer to take the next upsell on
							most OTOs.</p>
					</div>
				</template>
			</v-switch>
		</div>
		<div class="layout-row flex bundle" v-if="automation.content.bundle" >
			<span>Wait at least</span>
			<input-field class="bundle-field" small type="number" append="minutes" :max="60" :min="1"
			             v-model.number="automation.content.trigger_after" @input="updated" />
			<span>for the next order before bundling.</span>
		</div>
	</div>
</div>
</template>

<script>
import API from "@/api"
import VSwitch from "@/components/base/v-switch";
import SelectField from "@/components/base/select-field";
import InputField from "@/components/base/input-field";

export default {
  name: 'ShipStation',
  components: {
	  InputField,
    SelectField,
    VSwitch,
  },
  mixins: [API],
	props:{
		automation:{
			type:Object,
			// default:()=> {}
		},
		product:{
			type:Object,
		},
		actions:{
			type:Array,
		},
		integration:{
			type:Object,
		},
	},
  data() {
    return {
      stores:[],
      products:[],
      spin: false,
      acLists: [],
    }
  },
  computed: {
		isValid(){
			return (!!this.automation.type_id) && (!!this.automation.content.sku) && (!!this.automation.content.qty)
		}
  },
  methods: {
    async acListSelect(val) {
	    let p = this.products.find(item => parseInt(item.id) === parseInt(val));
	    this.automation.content.sku = p.sku || '';
	    this.automation.action_caption = p.name;

			this.updated()
    },
    async actionChanged(val) {
			this.$nextTick(()=>{
				this.updated();
			})
    },
    updated() {
	    if (!this.automation.content.trigger_after)
		    this.automation.content.trigger_after = 0;
	    if (!this.automation.content.qty)
		    this.automation.content.qty = 1;
	    this.$emit('valid', this.isValid)
    },
    async loadLists() {
	    try {
		    this.spin = true

		    let stores = await this.api.integrations.method(this.integration.name, 'get-stores', {});
		    if (stores.error) {
			    throw stores
		    }
		    this.stores = stores;

		    let products = await this.api.integrations.method(this.integration.name, 'get-products', {
			    "id": 0,
			    "arg1": '',
			    "arg2": '',
		    });
		    if (products.error) {
			    throw products
		    }
		    this.products = products;

		    // if (!acRes || acRes.error)
			  //   this.$error(acRes, "Integration error! Check your integration credentials and try again.");
		    // else
			  //   this.acLists = acRes;
	    } catch (e) {
		    this.$error(e)
	    } finally {
		    this.spin = false;
		    this.updated()
	    }
    }
  },
  async created() {
    if (this.automation) {
	    if (!this.automation.content)
		    this.$set(this.automation, 'content', {})
    }
		await this.loadLists()
  },
}
</script>
<style lang="scss" scoped>
.__action-part-shipstation {

}
.bundle-field {
	width: 130px;
	min-width: 130px;
	max-width: 130px;
}
.form-group.with_top_block {
	margin: 0;
}
.switch-container{
	margin: auto;
}
.qty {
	width: 100px;
}
.bundle {
	background: $light-blue;
	border: 1px solid $light-blue;
	border-radius: 6px;
	padding: 10px 15px;
	gap: 6px;
	display: flex;
	flex-direction: row;
	align-items: center;
}
</style>
